import {IDefaultAirlineParameter, IFlightSchedule} from '@/types/ci';
import {createSlice} from '@reduxjs/toolkit';

interface CiState {
  seasonalWinds: string;
  defaultAirlineParameter: IDefaultAirlineParameter | null;
  flightSchedule: IFlightSchedule | null;
  isDataUpToDate: boolean;
}

const initialState: CiState = {
  seasonalWinds: 'NH Summer',
  defaultAirlineParameter: null,
  flightSchedule: null,
  isDataUpToDate: true
};

const ciSlice = createSlice({
  name: 'ciSlice',
  initialState,
  reducers: {
    setSeasonalWinds: (state, action: {payload: string}) => {
      state.seasonalWinds = action.payload;
    },
    setDefaultAirlineParameter: (state, action) => {
      state.defaultAirlineParameter = action.payload;
    },
    setAirlineParameterWithKey: (
      state,
      action: {payload: {key: string; value: any}}
    ) => {
      const {key, value} = action.payload;
      if (state.defaultAirlineParameter) {
        state.defaultAirlineParameter = {
          ...state.defaultAirlineParameter,
          [key]: value
        };
      }
    },
    setFlightSchedule: (state, action: {payload: IFlightSchedule}) => {
      state.flightSchedule = action.payload;
    },
    setIsDataUpToDate: (state, action: {payload: boolean}) => {
      state.isDataUpToDate = action.payload;
    }
  }
});

export const {
  setSeasonalWinds,
  setDefaultAirlineParameter,
  setAirlineParameterWithKey,
  setFlightSchedule,
  setIsDataUpToDate
} = ciSlice.actions;
export default ciSlice.reducer;
